import { createContext } from "react";

export type SpeechToTextStatus = "idle" | "connecting" | "recording";

export type SpeechToTextContextValue = {
    activeFieldId: string | null;
    status: SpeechToTextStatus;
    micPermissionDenied: boolean;
    // Live, not-yet-committed transcript text for whichever field is currently active. Only
    // meaningful when read alongside activeFieldId — it's shared/global, not per-field.
    partialText: string;
    // Set to a field's id right after that field's session was auto-stopped for hitting the
    // 2-minute limit, until the notice dismisses itself or the user acts. Not the same as
    // activeFieldId — by the time this is set, the field is no longer active.
    sessionLimitFieldId: string | null;
    start: (fieldId: string, onCommittedText: (text: string) => void) => void;
    stop: (fieldId: string) => void;
};

export const SpeechToTextContext = createContext<SpeechToTextContextValue>(null);
